import { selectRouteToIdentity } from "./selectRouteToIdentity";
import { ContentContainer, PageContainer, TextContent, TitleText } from "./unauthorized.styles";
import { ProjectLogoComponent } from "../../../infecto-lms-webapp-impl/components/ProjectLogo.component";
import { useTypedDispatch } from "../../redux/redux-store";
import { logoutWithoutRedirect } from "../../redux/slices/auth.slice";

export const DoccheckUnauthorizedScreen = () => {
	const dispatch = useTypedDispatch();

	const handleLogout = () => {
		dispatch(logoutWithoutRedirect());
	};

	return (
		<PageContainer>
			<div className="w-full flex align-items-center justify-content-center">
				<ContentContainer>
					<TitleText className="mb-5">Kein Zugang mit DocCheck</TitleText>
					<TextContent>
						DocCheck-Nutzer können sich bei der PädiaAkademie nicht einloggen, da die Plattform nur
						für registrierte Nutzer zugänglich ist.
					</TextContent>
					<TextContent>
						Bitte{" "}
						<a
							onClick={handleLogout}
							className="text-primary"
							rel="noopener noreferrer"
							href={selectRouteToIdentity("registration")}
						>
							registrieren
						</a>{" "}
						Sie sich direkt bei Pädia oder melden Sie sich{" "}
						<a
							onClick={handleLogout}
							className="text-primary"
							rel="noopener noreferrer"
							href={selectRouteToIdentity("login")}
						>
							hier
						</a>{" "}
						mit einem bestehenden Benutzerkonto an.
					</TextContent>
					<div className="mt-5">
						<ProjectLogoComponent width={300} />
					</div>
				</ContentContainer>
			</div>
		</PageContainer>
	);
};
